import MineDamageLogic from "../../../logic/MineDamageLogic";
import { Settings } from "../../../Settings";
import Damage from "../../crew/Damage";
import Totals from "../../crew/Totals";
import BigNum from "../../math/BigNum";
import GoldUpgrade from "./GoldUpgrade";
import UpgradeCostCalculator from "../classic/UpgradeCostCalculator";
import NumberFormatter from "../../../util/NumberFormatter";

export default class DamageBonusGoldUpgrade extends GoldUpgrade {
    /**
     * @param {string} id
     * @param {string} title
     * @param {string} iconFileName
     * @param {UpgradeCostCalculator} upgradeCostCalculator 
     * @param {number} maxCount
     * @param {Totals} totals
     * @param {MineDamageLogic} mineDamageLogic
     * @param {Damage} damage
     * @param {BigNum} damageMultiplier This is the property of Damage that is being upgraded.
     */
    constructor(id, title, iconFileName, upgradeCostCalculator, maxCount, totals, mineDamageLogic, damage, damageMultiplier) {
        super(id, title, iconFileName, upgradeCostCalculator, maxCount, totals);

        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @constant
         * @type {BigNum}
         */
        this.damageMultiplier = damageMultiplier;

        /**
         * @constant
         * @type {MineDamageLogic}
         */
        this.mineDamageLogic = mineDamageLogic;

        /**
         * @constant
         * @type {BigNum}
         */
        this.displayedMultiplier = new BigNum(-10);

        /**
         * @type {string}
         */
        this.description = null;
    }

    /**
     * @override
     * @returns {string}
     */
    getDescription() {

        if (!this.description || !this.damageMultiplier.equals(this.displayedMultiplier)) {
            this.displayedMultiplier.copy(this.damageMultiplier);
            this.description = 'x' + NumberFormatter.formatBigNum(this.damageMultiplier);
        }

        return this.description;
    }

    /**
     * Invoked by the base class to let the sub-class know that a purchase has been made.
     * @override
     * @param {number} currentCount This is the before value.
     * @param {number} purchaseCount 
     */
    onUpgradePurchased(currentCount, purchaseCount) {
        super.onUpgradePurchased(currentCount, purchaseCount);

        const goldDamageMultiplier = this.damageMultiplier;

        if (goldDamageMultiplier.equalsZero()) {
            goldDamageMultiplier.setValue(1);
        }

        const goldUnitMultiplier = new BigNum(Settings.gold.damageMultiplierPerUpgrade);

        for (let i = 0; i < purchaseCount; i++) {
            goldDamageMultiplier.multiply(goldUnitMultiplier);            
        }

        this.mineDamageLogic.calculateTotalMineDamagePerTurn(); 
    }

}